export const SERVICE = 'CALL_ME_BACK'
